import { render, staticRenderFns } from "./pagesBottom.vue?vue&type=template&id=29054966&scoped=true"
import script from "./pagesBottom.vue?vue&type=script&lang=js"
export * from "./pagesBottom.vue?vue&type=script&lang=js"
import style0 from "./pagesBottom.vue?vue&type=style&index=0&id=29054966&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29054966",
  null
  
)

export default component.exports